import React, { useContext } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import Spinner from '../Nav/Spinner'
import { __ } from 'i18n-for-browser'

export default function BannerReflow () {
    const { adSizes } = useContext(EasybakeContext)
    const { spinnerTimeout, wait, group } = useContext(EasybakeContext)
    const caption = `${__('bannerreflow_applying')}\u2026`

    function getOriginal () {
        const landscapeSizes = adSizes.filter(size => size.name === 'Original')
        return landscapeSizes.map(size => {
            return getPreview(size, 'original')
        })
    }

    function getLandscapes () {
        const landscapeSizes = adSizes.filter(size => (size.orientation === 'landscape') && (size.checked === true))
        return landscapeSizes.map(size => {
            return getPreview(size, 'landscape')
        })
    }

    function getPortraits () {
        const portraitSizes = adSizes.filter(size => (size.orientation === 'portrait' && size.checked === true) || (size.orientation === 'square' && size.checked === true))
        return portraitSizes.map(size => {
            return getPreview(size, 'portrait')
        })
    }

    function getPreview (size, orientation, wait) {
        return <div className="adobe-easybake-banner-preview">
            <div className="adobe-easybake-banner-preview-info">
                <div className={`adobe-easybake-banner-preview-info-name adobe-easybake-banner-preview-info-name-${size.name}`}>{size.name}</div>
                <div className={`adobe-easybake-banner-preview-info-name-${size.name}`}>{size.label}</div>
            </div>
            <img className={`fadeIn adobe-easybake-banner-preview-image-${orientation}`} src={size.image} alt={size.label} />
            {getSpinner()}
        </div>
    }

    function getSpinner () {
        if (wait) {
            return <Spinner timeout={spinnerTimeout} caption={caption} className="reflowspinner"/>
        }
        return null
    }

    return (
        <div className="adobe-easybake-main-pane">
            <div className="adobe-easybake-main adobe-easybake-bannerreflow">
                <div className="adobe-easybake-banner-previews">
                    {group && wait &&
                        <React.Fragment>
                            <div className="adobe-easybake-banner-previews-original-loading">
                                {getOriginal()}
                            </div>
                        </React.Fragment>
                    }
                    {group && !wait &&
                        <React.Fragment>
                            <div className="adobe-easybake-banner-previews-landscape">{getLandscapes()}</div>
                            <div>{getPortraits()}</div>
                        </React.Fragment>
                    }
                    {!group &&
                        <React.Fragment>
                            <div className="adobe-easybake-banner-previews-landscape">{getLandscapes()}</div>
                            <div>{getPortraits()}</div>
                        </React.Fragment>
                    }
                </div>
            </div>
        </div>)
}
